export function hasCurrentNflRoster(players = []) {
  return players.some((player) => player.current);
}

export function visibleNflTeamPlayers(players = [], tab = "roster") {
  if (tab === "all") return players;
  const current = players.filter((player) => player.current);
  return current.length > 0 ? current : players;
}
